import { type DetectorProfile } from "@/components/domain/detector-profile"

import {
  type ClientRow,
  type ClientUserOption,
  type PrimaryClientContact,
  type StaffOption,
  type UserId,
} from "./clients-data"
import { ExpandedMembers, type MemberActions } from "./clients-members"
import { EngagementProfileEditor } from "./clients-profile"
import { PrimaryClientContactControl } from "./clients-pcc"

/**
 * An engagement opened in the table: who gets its new reviews, what its
 * reviews check by default, and who at the client can see them.
 */
export function ExpandedEngagement({
  row,
  users,
  memberActions,
  primaryClientContact,
  primaryClientContactCandidates,
  onPrimaryClientContactChange,
  onSaveProfile,
}: {
  row: ClientRow
  users: readonly ClientUserOption[]
  memberActions: MemberActions
  primaryClientContact: PrimaryClientContact | null
  primaryClientContactCandidates: readonly StaffOption[]
  onPrimaryClientContactChange: (primaryClientContactId: UserId | null) => Promise<void>
  onSaveProfile: (profile: DetectorProfile) => Promise<void>
}): JSX.Element {
  return (
    <ExpandedMembers
      row={row}
      users={users}
      actions={memberActions}
      header={
        <div className="space-y-5">
          <PrimaryClientContactControl
            primaryClientContact={primaryClientContact}
            primaryClientContactCandidates={primaryClientContactCandidates}
            onPrimaryClientContactChange={onPrimaryClientContactChange}
          />
          <EngagementProfileEditor saved={row.detectorProfile} onSave={onSaveProfile} />
        </div>
      }
    />
  )
}
